import React, { useState } from "react";
import {
  emailValidation,
  notEmptyValidation,
  urlValidation,
} from "../../../functions/validation";
import axios from "axios";
import { authAPI, searchAPI } from "../../../apis";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const InputText = (props) => {
  const {
    placeholder,
    value,
    onChange,
    name,
    validation,
    errorText,
    setErrorText,
    customValidation,
    height,
  } = props;

  const [error, seterror] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const checkUniqueUsername = async () => {
    try {
      let url;
      if (value.length === 0) {
        setErrorText(`Username cannot be empty.`);
        seterror(true);
        return;
      }
      if (user) {
        url = `${authAPI.uniqueUsername}?userName=${value}&userId=${user.userId}`;
      } else {
        url = `${authAPI.uniqueUsername}?userName=${value}`;
      }
      const { data } = await axios.get(url);
      if (data === "UserName is available") {
        setErrorText(`Username ${value} is available.`);
        seterror(false);
      }
      if (data === "Same UserName for the UserId") {
        setErrorText("");
        seterror(false);
      }
    } catch (e) {
      setErrorText(e.response.data);
      seterror(true);
      console.log(e);
    }
  };

  function checkValidation() {
    if (validation === "ne") {
      !notEmptyValidation(value) &&
        seterror(errorText ? errorText : `${placeholder} is required`);
    } else if (validation === "email") {
      !emailValidation(value) &&
        seterror(errorText ? errorText : "Invalid E-mail Address");
    } else if (validation === "url") {
      !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
    } else if (validation === "custom") {
      !customValidation() && seterror("Email and Confirm Email do not match.");
    } else if (validation === "username") {
      checkUniqueUsername();
    } else {
      seterror(null);
    }
  }

  return (
    <div className={`input-text ${error ? "input-error" : ""}`}>
      <div className={`input ${height ? "height" : ""}`}>
        <input
          type="text"
          placeholder={error ? error : placeholder}
          value={value}
          onChange={(e) => {
            seterror(null);
            onChange(e);
          }}
          name={name}
          onBlur={checkValidation}
        />
      </div>
    </div>
  );
};

export default InputText;
